import { useState } from "react";
import { categories } from "@/mocks/navData";

export default function IndexList() {
  const [active, setActive] = useState(categories[0].key);
  const current = categories.find((c) => c.key === active) ?? categories[0];

  return (
    <section id="index" className="scroll-mt-20">
      <div className="mx-auto w-full max-w-[1240px] px-4 py-14 md:px-6 md:py-20">
        {/* heading */}
        <div className="mx-auto max-w-2xl text-center">
          <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.22em] text-[#b0843f]">
            <i className="ri-list-ordered-2 text-sm"></i>
            编号合集 · 按区直达
          </span>
          <h2 className="mt-4 text-3xl font-bold leading-tight text-[#2a2016] md:text-4xl">
            认准编号，下次直接按号找
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-[#6b5d48]">
            每条入口都有独立编号与时效标注，收藏一条、少搜十次。
            想要什么就切到哪个分区，列表一路往下，点开即用。
          </p>
        </div>

        {/* segmented control */}
        <div className="mt-8 flex justify-center">
          <div className="inline-flex flex-wrap items-center justify-center gap-1 rounded-full border border-[#ead9bd] bg-[#fffdf8] p-1">
            {categories.map((c) => (
              <button
                key={c.key}
                type="button"
                onClick={() => setActive(c.key)}
                className={`cursor-pointer whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors ${
                  active === c.key
                    ? "bg-[#e4562b] text-white"
                    : "text-[#6b5d48] hover:text-[#e4562b]"
                }`}
              >
                {c.name}
              </button>
            ))}
          </div>
        </div>

        {/* active category intro */}
        <div className="mx-auto mt-8 max-w-2xl rounded-2xl border border-[#ead9bd] bg-[#f7eedb] px-5 py-4 text-center">
          <p className="text-sm leading-relaxed text-[#6b5d48]">{current.intro}</p>
        </div>

        {/* numbered list */}
        <div className="mt-6 overflow-hidden rounded-2xl border border-[#ead9bd] bg-[#fffdf8]">
          {current.entries.map((entry, i) => (
            <a
              key={`${current.key}-${entry.index}`}
              href={entry.href}
              className={`group flex cursor-pointer flex-col gap-3 px-5 py-5 transition-colors hover:bg-[#fdf4e4] sm:flex-row sm:items-center sm:px-7 ${
                i !== current.entries.length - 1 ? "border-b border-[#f0e3cd]" : ""
              }`}
            >
              <span className="text-2xl font-black leading-none text-[#d9b57e] tabular-nums sm:w-12">
                {String(entry.index).padStart(2, "0")}
              </span>
              <span className="min-w-0 flex-1">
                <span className="flex flex-wrap items-center gap-2">
                  <span className="truncate text-base font-bold text-[#2a2016]">
                    {entry.title}
                  </span>
                  <span className="rounded-full bg-[#e4562b]/10 px-2 py-0.5 text-[11px] font-semibold text-[#e4562b]">
                    {entry.tag}
                  </span>
                </span>
                <span className="mt-1 hidden text-sm text-[#8a7c64] sm:block">{entry.note}</span>
              </span>
              <span className="flex shrink-0 items-center gap-3 text-xs text-[#8a7c64] sm:gap-4">
                <span className="hidden items-center gap-1 md:inline-flex">
                  <i className="ri-time-line text-[#b0843f]"></i>
                  {entry.time}
                </span>
                <span className="inline-flex items-center gap-1">
                  <i className="ri-fire-line text-[#e4562b]"></i>
                  {entry.read}
                </span>
                <span className="flex h-8 w-8 items-center justify-center rounded-full bg-[#f0e3cd] text-[#b0843f] transition-colors group-hover:bg-[#e4562b] group-hover:text-white">
                  <i className="ri-arrow-right-up-line text-base"></i>
                </span>
              </span>
            </a>
          ))}
        </div>

        <div className="mt-6 text-center">
          <a
            href="#top"
            className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap text-sm font-semibold text-[#e4562b] hover:text-[#c8421c]"
          >
            回到首屏继续挑
            <i className="ri-arrow-right-up-line text-base"></i>
          </a>
        </div>
      </div>
    </section>
  );
}